import { computed } from '@nuxtjs/composition-api';
import { useZendeskEmail } from '@unified-commerce/gpc-vue-storefront-in-house';
import { getVehicleRecords, useVehicleSearch } from '@unified-commerce/gpc-vue-storefront-search';
import debounce from 'lodash/debounce';

interface ISubmitPayload {
  token: string;
  emailBody: {
    [formField: string]: string;
  };
  userEmail: string;
}

interface UseContactFormProps {
  formId: string;
  emailSubject: string;
}

const useContactForm = ({ formId, emailSubject }: UseContactFormProps) => {
  const {
    sendZendeskEmail,
    zendeskEmailResponse: response,
    zendeskEmailLoading: loading,
    zendeskEmailError: error,
  } = useZendeskEmail(`contact-${formId}`);
  const {
    search,
    result: vehicleSearchResponse,
    loading: vehicleSearchLoading,
    error: vehicleSearchErrorRaw,
  } = useVehicleSearch(`vehicle-search-${formId}`);

  const onVehicleSearchInput = debounce(async (query: string) => {
    await search({
      query,
      resultsPerPage: 15,
    });
  }, 500);

  const onSubmit = ({ token, emailBody, userEmail }: ISubmitPayload) =>
    sendZendeskEmail(token, emailBody, userEmail, emailSubject);

  const vehicleSearchResults = computed<string[]>(() =>
    (getVehicleRecords(vehicleSearchResponse.value) ?? []).map((vehicle) => vehicle.name),
  );

  const vehicleSearchError = computed(() => vehicleSearchErrorRaw.value.search);

  return {
    response,
    loading,
    error,
    vehicleSearchResults,
    vehicleSearchLoading,
    vehicleSearchError,
    onVehicleSearchInput,
    onSubmit,
  };
};

export default useContactForm;
